import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { StateManagementService } from "providers/state-management/state-management.service";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";

export interface DictationTranscriptionResponse {
  transcribe: string;
}

@Injectable()
export class DictationTranscriptionService {
  private apiUrl: string;
  private mock: boolean = false;

  constructor(
    private http: HttpClient,
    private configSrvc: ConfigurationService,
    public stateMgmtSrvc: StateManagementService
  ) {
    // Set Reference To All Config & The Base API URL
    const config = this.configSrvc.getConfig();
    this.apiUrl = config.apiUrl;

    // Set The API URL To The Local Endpoint Or The Default API URL
    if (config.isLocal && config.localEndpoints.aiVoiceDictationTranscription) {
      this.apiUrl = config.localEndpoints.aiVoiceDictationTranscription;
    } else {
      this.apiUrl = config.apiUrl + "/curantis-gateway/murphi/transcribe";
    }
  }

  public postDictationTranscription(
    dictationTranscriptionRequest: Blob
  ): Observable<DictationTranscriptionResponse> {
    // If Mock Flag Is Set, Return A Dummy Observable
    if (this.mock) {
      return of({
        transcribe: "Test test test",
      });
    }

    // NOVA-1866: Pass The Current Patient Chart Id So Murphi Receives It As
    // The userid, Like Pre-Visit Summary And IDG Do. The Body Is The Audio
    // Blob, So The Chart Id Rides A Query Parameter. Without It The Gateway
    // Falls Back To The User Id.
    const chartId = this.stateMgmtSrvc.getChartId();
    const url = chartId
      ? this.apiUrl + "?patientChartId=" + encodeURIComponent(chartId)
      : this.apiUrl;

    // Otherwise, Make A POST Request To The API
    // {
    //   "transcribe": "Test test test p"
    // }
    return this.http.post<DictationTranscriptionResponse>(
      url,
      dictationTranscriptionRequest
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/dictation-transcription/dictation-transcription.service.ts